import gqlApi from '../../api/gql'

// initial state
const state = () => ({
  globalStyles: [],
  globalStylesUiMeta: [],
  globalStyle: {},

  pageBuilders: [],
  pageBuildersUiMeta: [],
  pageBuilder: {},

  sectionBuilderEditorsUiMeta: [],
  sectionBuilderEditors: [],
  sectionBuilders: [],
  sectionBuildersUiMeta: [],
  sectionBuilder: {},
})

// getters
const getters = {}

// actions
const actions = {
  listGlobalStyles({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListGlobalStyles{
            created_at
            invisible_id
            name
            is_default
            updated_at
          }
        }
      `,
      variables: {
        name: 'GlobalStyleListVo',
      }
    }).then(data => {
      commit('set', ['globalStylesUiMeta', data.GetUiMeta])
      commit('setGlobalStyles', data.ListGlobalStyles)
      return true
    })
  },
  getGlobalStyle({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetGlobalStyle(id: $id){
            created_at
            id
            name
            is_default
            style
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setGlobalStyle', resp.GetGlobalStyle)
      return true
    })
  },
  addGlobalStyle(_, globalStyle) {
    return gqlApi.query({
      query: `    
        mutation($input: GlobalStyleAddVo){
          AddGlobalStyle(input: $input){
            id
          }
        }
      `,
      variables: {
        input: globalStyle,
      },
    }).then(() => {
      return true
    })
  },
  updateGlobalStyle(_, globalStyle) {
    return gqlApi.query({
      query: `    
        mutation($input: GlobalStyleUpdateVo){
          UpdateGlobalStyle(input: $input){
            id
          }
        }
      `,
      variables: {
        input: globalStyle,
      },
    }).then(() => {
      return true
    })
  },
  deleteGlobalStyle(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteGlobalStyle(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listPageBuilders({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListPageBuilders{
            created_at
            invisible_id
            name
            path
            section_builders_names
            updated_at
          }
        }
      `,
      variables: {
        name: 'PageBuilderListVo',
      }
    }).then(data => {
      commit('set', ['pageBuildersUiMeta', data.GetUiMeta])
      commit('setPageBuilders', data.ListPageBuilders)
      return true
    })
  },
  
  getPageBuilder({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetPageBuilder(id: $id){
            created_at
            global_style_id
            id
            name
            path
            section_builder_ids
            seo_info
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(data => {
      commit('setPageBuilder', data.GetPageBuilder)
      return true
    })
  },
  addPageBuilder (_, pageBuilder) {
    return gqlApi.query({
      query: `    
        mutation($input: PageBuilderAddVo){
          AddPageBuilder(input: $input){
            id
          }
        }
      `,
      variables: {
        input: pageBuilder,
      },
    }).then(() => {
      return true
    })
  },
  updatePageBuilder (_, pageBuilder) {
    return gqlApi.query({
      query: `    
        mutation($input: PageBuilderUpdateVo){
          UpdatePageBuilder(input: $input){
            id
          }
        }
      `,
      variables: {
        input: pageBuilder,
      },
    }).then(() => {
      return true
    })
  },
  deletePageBuilder(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeletePageBuilder(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },
  
  listSectionBuilderEditors({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListSectionBuilderEditors{
            name
            path
            section_builders {
              id
              name
            }
          }
        }
      `,
      variables: {
        name: 'SectionBuilderEditorListVo',
      }
    }).then(data => {
      commit('set', ['sectionBuilderEditorsUiMeta', data.GetUiMeta])
      commit('setSectionBuilderEditors', data.ListSectionBuilderEditors)
      return true
    })
  },

  listSectionBuilders({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListSectionBuilders{
            invisible_id
            name
            status
            created_at
            updated_at
          }
        }
      `,
      variables: {
        name: 'SectionBuilderListVo',
      }
    }).then(data => {
      commit('set', ['sectionBuildersUiMeta', data.GetUiMeta])
      commit('setSectionBuilders', data.ListSectionBuilders)
      return true
    })
  },
  getDraftSectionBuilder({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetDraftSectionBuilder(id: $id){
            created_at
            id
            name
            static_data
            style
            template
            updated_at
          }
          
        }
      `,
      variables: {
        id,
      },
    }).then(data => {
      commit('setSectionBuilder', data.GetDraftSectionBuilder)
      return true
    })
  },
  getSectionBuilderByName({ commit }, name) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetSectionBuilderByName(name: $name){
            static_data
            style
            template
          }
          
        }
      `,
      variables: {
        name,
      },
    }).then(data => {
      commit('setSectionBuilder', data.GetSectionBuilderByName)
      return true
    })
  },
  addDraftSectionBuilder(_, {input, isDeploy}) {
    return gqlApi.query({
      query: `    
        mutation($input: SectionBuilderAddDraftVo, $isDeploy: Boolean){
          AddDraftSectionBuilder(input: $input, isDeploy: $isDeploy){
            id
          }
        }
      `,
      variables: {
        input,
        isDeploy: isDeploy ? isDeploy : false,
      },
    }).then(() => {
      return true
    })
  },
  updateDraftSectionBuilder(_, {input, isDeploy}) {
    return gqlApi.query({
      query: `    
        mutation($input: SectionBuilderUpdateDraftVo, $isDeploy: Boolean){
          UpdateDraftSectionBuilder(input: $input, isDeploy: $isDeploy){
            id
          }
        }
      `,
      variables: {
        input,
        isDeploy: isDeploy ? isDeploy : false,
      },
    }).then(() => {
      return true
    })
  },
  discardDraftSectionBuilder(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DiscardDraftSectionBuilder(id: $id){
            id
          }
        }
      `,
      variables: {
        id: id,
      },
    }).then(() => {
      return true
    })
  },
  deleteSectionBuilder(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteSectionBuilder(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },
}

// mutations
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setSectionBuilder (state, sectionBuilder) {
    state.sectionBuilder = sectionBuilder
  },
  setSectionBuilderEditors (state, sectionBuilderEditors) {
    state.sectionBuilderEditors = sectionBuilderEditors
  },
  setSectionBuilders (state, sectionBuilders) {
    state.sectionBuilders = sectionBuilders
  },
  setPageBuilder (state, pageBuilder) {
    state.pageBuilder = pageBuilder
  },
  setPageBuilders (state, pageBuilders) {
    state.pageBuilders = pageBuilders
  },
  setGlobalStyles (state, globalStyles) {
    state.globalStyles = globalStyles
  },
  setGlobalStyle (state, globalStyle) {
    state.globalStyle = globalStyle
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}